import { useNavigate } from 'react-router';
import { Box, Button, Flex, Heading, IconButton } from '@chakra-ui/react';
import { RiAddFill, RiFilter2Line } from 'react-icons/ri';
import { useAuthContext } from '@contexts/auth'

import List from './components/List';
import ImportButton from './components/ImportButton';
import Filters from './components/Filters';
import { CustomersProvider, useCustomersContext } from './context';
import SelectedFiltersList from './components/SelectedFiltersList';

const Page = () => {
  const navigate = useNavigate();

  const { checkIfHasRole } = useAuthContext();

  const { showFilters, setShowFilters } = useCustomersContext();

  return (
    <Box >
      <Flex justifyContent="space-between" alignItems="flex-end" mb={2}>
        <Flex alignItems="center">
          <Heading>
            Clientes
          </Heading>
          <IconButton
            variant="ghost"
            color="argos.fg"
            onClick={() => setShowFilters((prev) => !prev)}
          >
            <RiFilter2Line size={24} />
          </IconButton>
        </Flex>
        <Flex gap={2}>
          {checkIfHasRole('CAN_IMPORT_CUSTOMERS') && (
            <ImportButton />
          )}
          {checkIfHasRole('CAN_CREATE_CUSTOMERS') && (
            <Button size="sm" onClick={() => navigate('/painel/clientes/criar')}>
              <RiAddFill /> Novo
            </Button>
          )}
        </Flex>
      </Flex>

      {showFilters ? (
        <Filters />
      ) : (
        <SelectedFiltersList />
      )}

      <List />
    </Box>
  );
};

const Customer = () => (
  <CustomersProvider>
    <Page />
  </CustomersProvider>
);

export default Customer;
